module.exports = __webpack_public_path__ + "img/0-17.3edf233f.gif";